export const updateSplidePagination = (newIndex: number, slider: any): void => {

  const FIRST_PAGE = 'first-page';
  const SECOND_PAGE = 'second-page';
  const LAST_PAGE = 'last-page';
  const SECOND_LAST_PAGE = 'second-last-page';
  const IS_ACTIVE = 'is-active';
  const IS_AROUND = 'is-around';
  const SHOW_DOTS = 'show-dots';
  const IS_NEXT_TO = 'is-next-to';

  const pagination = slider.Components.Pagination;
  const pages = pagination.items;
  const paginationContainer = pages[0].li.parentNode;
  const lastPage = pages.length - 1;

  if (lastPage >= 10) {
    paginationContainer.classList.add('simplify-page-list-always');
  } else if (lastPage >= 7) {
    paginationContainer.classList.add('simplify-page-list-m');
  } else if (lastPage >= 5) {
    paginationContainer.classList.add('simplify-page-list-s');
  }

  if (lastPage <= 5) {
    return;
  }

  pages.forEach((page: any) => {

    page.li.classList.remove(IS_ACTIVE, IS_AROUND, SHOW_DOTS, IS_NEXT_TO);

    if (page.page === 0) page.li.classList.add(FIRST_PAGE);
    if (page.page === 1) page.li.classList.add(SECOND_PAGE);
    if (page.page === lastPage) page.li.classList.add(LAST_PAGE);
    if (page.page === lastPage - 1) page.li.classList.add(SECOND_LAST_PAGE);

    if (page.page === newIndex) {
      page.li.classList.add(IS_ACTIVE);
      return;
    }

    if (page.page === 0 || page.page === lastPage) {
      return;
    }

    if(Math.abs(page.page - newIndex) === 1){
      page.li.classList.add(IS_NEXT_TO);
    }

    if (
      newIndex >= 4 && page.page === 1 ||
      (newIndex < lastPage - 2 && page.page === lastPage - 1)
    ) {
      page.li.classList.add(SHOW_DOTS);
    }

    if (
      Math.abs(page.page - newIndex) === 1 ||
      (newIndex < 4 && page.page <= 4) ||
      (newIndex >= lastPage - 3 && page.page >= lastPage - 4)
    ) {
      page.li.classList.add(IS_AROUND);
    }

  })
}
